import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createExternalFinishing } from "../../helpers/http_external_finishings_requests";

export default function ExternalFinishingNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Formato de Produto",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createExternalFinishing(data, () => navigate('/acabamentos-externos'))
    };

    return <DynamicFormPage title={"Acabamentos Externos - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
